/* OFT Product Comparison v6 — category-aware comparison table */
(function () {
  'use strict';

  var KEY = 'oft_cmp_v6';
  var MAX = 4;
  var items = [];

  /* ── Storage ── */
  function load() { try { items = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { items = []; } }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { } }
  function byId(id) { return items.find(function (x) { return x.id === String(id); }); }

  /* ── Helpers ── */
  function isRefurb(item) {
    if (item.condition === 'Refurbished') return true;
    return (item.tags || []).some(function (t) {
      var tl = String(t).toLowerCase();
      return tl === 'hn-cer' || tl === 'hnused';
    });
  }

  function money(v) {
    var n = parseFloat(String(v || '0').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? '' : '\u00a3' + n.toFixed(2).replace(/\.00$/, '');
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function hasTag(tags, words) {
    var tl = (tags || []).map(function (t) { return String(t).toLowerCase(); });
    return words.some(function (w) { return tl.some(function (t) { return t.indexOf(w) !== -1; }); });
  }

  function inStr(str, words) {
    var s = String(str || '').toLowerCase();
    return words.some(function (w) { return s.indexOf(w) !== -1; });
  }

  /* ─────────────────────────────────────────────────────
     CATEGORY DETECTION
     Returns: 'chair' | 'desk' | 'storage' | 'table' | 'other'
  ───────────────────────────────────────────────────── */
  var CHAIR_TITLE   = ['chair', 'seating', 'stool', 'operator', 'task chair', 'armchair', 'tub chair'];
  var CHAIR_TYPES   = ['chair', 'seating', 'ergonomic chair', 'office chair', 'operator chair',
                       'executive chair', 'task chair', 'visitor chair', 'meeting chair',
                       'ergonomic office chair'];
  var CHAIR_TAGS    = ['chair', 'seating', 'ergonomic', 'operator', 'task chair', 'swivel'];

  var DESK_TITLE    = ['desk', 'workstation', 'sit-stand', 'sit stand', 'height adjustable desk',
                       'standing desk', 'bench desk'];
  var DESK_TYPES    = ['desk', 'workstation', 'office desk', 'standing desk', 'sit-stand desk'];
  var DESK_TAGS     = ['desk', 'workstation', 'sit-stand', 'height adjustable desk'];

  var STORAGE_TITLE = ['cabinet', 'cupboard', 'pedestal', 'locker', 'bookcase', 'tambour',
                       'shelving', 'filing', 'drawer unit', 'storage unit', 'wardrobe'];
  var STORAGE_TYPES = ['cabinet', 'cupboard', 'pedestal', 'storage', 'filing cabinet',
                       'office storage', 'locker', 'bookcase', 'tambour unit'];
  var STORAGE_TAGS  = ['cabinet', 'cupboard', 'pedestal', 'storage', 'filing', 'locker',
                       'bookcase', 'tambour'];

  var TABLE_TITLE   = ['table', 'boardroom table', 'meeting table', 'training table',
                       'folding table', 'canteen table', 'poseur table'];
  var TABLE_TYPES   = ['table', 'boardroom table', 'meeting table', 'training table'];
  var TABLE_TAGS    = ['table', 'boardroom', 'meeting table'];

  function detectCategory(item) {
    var title = (item.title || '').toLowerCase();
    var ptype = (item.ptype || '').toLowerCase();
    var tags  = item.tags || [];

    /* Storage first — highest priority since many products have "chair" in context */
    if (inStr(title, STORAGE_TITLE) || inStr(ptype, STORAGE_TYPES) || hasTag(tags, STORAGE_TAGS)) {
      return 'storage';
    }
    /* Desks */
    if (inStr(title, DESK_TITLE) || inStr(ptype, DESK_TYPES) || hasTag(tags, DESK_TAGS)) {
      return 'desk';
    }
    /* Tables */
    if (inStr(title, TABLE_TITLE) || inStr(ptype, TABLE_TYPES) || hasTag(tags, TABLE_TAGS)) {
      return 'table';
    }
    /* Chairs */
    if (inStr(title, CHAIR_TITLE) || inStr(ptype, CHAIR_TYPES) || hasTag(tags, CHAIR_TAGS)) {
      return 'chair';
    }
    return 'other';
  }

  /* Detect dominant category across all compared items */
  function dominantCategory(itemList) {
    var counts = { chair: 0, desk: 0, storage: 0, table: 0, other: 0 };
    itemList.forEach(function (item) {
      var cat = detectCategory(item);
      counts[cat] = (counts[cat] || 0) + 1;
    });
    /* If all same category, return it */
    var cats = Object.keys(counts).filter(function (k) { return counts[k] > 0; });
    if (cats.length === 1) return cats[0];
    /* Otherwise mixed */
    return 'mixed';
  }

  /* ─────────────────────────────────────────────────────
     FIELD DEFINITIONS PER CATEGORY
  ───────────────────────────────────────────────────── */
  var FIELDS = {
    chair: [
      { label: 'Price',              key: 'price' },
      { label: 'Brand',              key: 'brand' },
      { label: 'Condition',          key: 'condition' },
      { label: 'Best for',           key: 'chair_bestfor' },
      { label: 'Material',           key: 'chair_material' },
      { label: 'Back type',          key: 'chair_back' },
      { label: 'Arms',               key: 'chair_arms' },
      { label: 'Mechanism',          key: 'chair_mechanism' },
      { label: 'Lumbar support',     key: 'chair_lumbar' },
      { label: 'Seat height adj.',   key: 'chair_height' },
      { label: 'Delivery',           key: 'delivery' },
      { label: 'Warranty / returns', key: 'warranty' }
    ],
    storage: [
      { label: 'Price',              key: 'price' },
      { label: 'Brand',              key: 'brand' },
      { label: 'Condition',          key: 'condition' },
      { label: 'Product type',       key: 'ptype_display' },
      { label: 'Storage type',       key: 'storage_type' },
      { label: 'Colour / finish',    key: 'storage_colour' },
      { label: 'Material',           key: 'storage_material' },
      { label: 'No. of drawers',     key: 'storage_drawers' },
      { label: 'Lockable',           key: 'storage_lock' },
      { label: 'Shelves',            key: 'storage_shelves' },
      { label: 'Delivery',           key: 'delivery' },
      { label: 'Warranty / returns', key: 'warranty' }
    ],
    desk: [
      { label: 'Price',              key: 'price' },
      { label: 'Brand',              key: 'brand' },
      { label: 'Condition',          key: 'condition' },
      { label: 'Product type',       key: 'ptype_display' },
      { label: 'Desk type',          key: 'desk_type' },
      { label: 'Top finish',         key: 'desk_finish' },
      { label: 'Frame type',         key: 'desk_frame' },
      { label: 'Height adjustable',  key: 'desk_heightadj' },
      { label: 'Cable management',   key: 'desk_cable' },
      { label: 'Delivery',           key: 'delivery' },
      { label: 'Warranty / returns', key: 'warranty' }
    ],
    table: [
      { label: 'Price',              key: 'price' },
      { label: 'Brand',              key: 'brand' },
      { label: 'Condition',          key: 'condition' },
      { label: 'Product type',       key: 'ptype_display' },
      { label: 'Table type',         key: 'table_type' },
      { label: 'Top finish',         key: 'desk_finish' },
      { label: 'Foldable',           key: 'table_fold' },
      { label: 'Delivery',           key: 'delivery' },
      { label: 'Warranty / returns', key: 'warranty' }
    ],
    mixed: [
      { label: 'Price',              key: 'price' },
      { label: 'Brand',              key: 'brand' },
      { label: 'Condition',          key: 'condition' },
      { label: 'Product type',       key: 'ptype_display' },
      { label: 'Colour / finish',    key: 'generic_finish' },
      { label: 'Material',           key: 'generic_material' },
      { label: 'Delivery',           key: 'delivery' },
      { label: 'Warranty / returns', key: 'warranty' }
    ],
    other: [
      { label: 'Price',              key: 'price' },
      { label: 'Brand',              key: 'brand' },
      { label: 'Condition',          key: 'condition' },
      { label: 'Product type',       key: 'ptype_display' },
      { label: 'Delivery',           key: 'delivery' },
      { label: 'Warranty / returns', key: 'warranty' }
    ]
  };

  var NA = 'Not specified';

  /* ─────────────────────────────────────────────────────
     DERIVE VALUE FOR A FIELD KEY
  ───────────────────────────────────────────────────── */
  function derive(item, key) {
    var tags  = item.tags || [];
    var title = (item.title || '').toLowerCase();
    var ptype = (item.ptype || '').toLowerCase();
    var refurb = isRefurb(item);

    switch (key) {

      /* ── Universal fields ── */
      case 'price':
        return money(item.price) || NA;

      case 'brand':
        return item.vendor ? esc(item.vendor) : NA;

      case 'condition':
        return refurb
          ? '<span class="oft-badge-refurb">Refurbished</span>'
          : '<span class="oft-badge-new">New</span>';

      case 'delivery':
        return 'Free UK delivery available';

      case 'warranty':
        return refurb ? '30-day quality guarantee' : 'Full manufacturer warranty';

      case 'ptype_display':
        if (item.ptype && item.ptype.trim()) return esc(item.ptype);
        /* Fallback: infer from title */
        if (inStr(title, ['pedestal'])) return 'Pedestal';
        if (inStr(title, ['filing cabinet', 'file cabinet'])) return 'Filing Cabinet';
        if (inStr(title, ['cupboard'])) return 'Cupboard';
        if (inStr(title, ['locker'])) return 'Locker';
        if (inStr(title, ['bookcase'])) return 'Bookcase';
        if (inStr(title, ['tambour'])) return 'Tambour Unit';
        if (inStr(title, ['cabinet'])) return 'Cabinet';
        if (inStr(title, ['desk'])) return 'Office Desk';
        if (inStr(title, ['chair'])) return 'Office Chair';
        if (inStr(title, ['table'])) return 'Table';
        return NA;

      /* ── Chair-specific fields ── */
      case 'chair_bestfor':
        if (hasTag(tags, ['8 hour', 'task chair for 8'])) return '8-hour daily use';
        if (hasTag(tags, ['executive']) || inStr(title, ['executive'])) return 'Executive offices';
        if (hasTag(tags, ['meeting', 'visitor']) || inStr(title, ['visitor', 'meeting'])) return 'Meeting rooms';
        if (hasTag(tags, ['ergonomic']) || inStr(title, ['ergonomic'])) return 'Ergonomic / daily use';
        if (hasTag(tags, ['operator']) || inStr(title, ['operator'])) return 'Operator / call centre';
        return NA;

      case 'chair_material':
        if (inStr(title, ['mesh']) || hasTag(tags, ['mesh'])) return 'Mesh';
        if (inStr(title, ['leather']) || hasTag(tags, ['leather'])) return 'Leather / leather-look';
        if (inStr(title, ['fabric']) || hasTag(tags, ['fabric'])) return 'Fabric';
        return NA;

      case 'chair_back':
        if (inStr(title, ['high back'])) return 'High back';
        if (inStr(title, ['medium back'])) return 'Medium back';
        if (inStr(title, ['low back'])) return 'Low back';
        if (inStr(title, ['mesh'])) return 'Mesh back';
        return NA;

      case 'chair_arms':
        if (hasTag(tags, ['4d arm', 'adjustable armrest', '4d armrest'])) return '4D adjustable arms';
        if (hasTag(tags, ['height adjustable arm', 'adjustable arm'])) return 'Height adjustable arms';
        if (inStr(title, ['no arm', 'armless']) || hasTag(tags, ['no arm', 'armless'])) return 'No arms';
        if (inStr(title, ['with arm', 'with armrest']) || hasTag(tags, ['armrest'])) return 'With arms';
        return NA;

      case 'chair_mechanism':
        if (hasTag(tags, ['synchronised', 'synchro']) || inStr(title, ['synchro'])) return 'Synchronised';
        if (hasTag(tags, ['asynchro']) || inStr(title, ['asynchro'])) return 'Asynchronous';
        if (hasTag(tags, ['tilt']) || inStr(title, ['tilt'])) return 'Tilt';
        return NA;

      case 'chair_lumbar':
        if (hasTag(tags, ['adjustable lumbar']) || inStr(title, ['adjustable lumbar'])) return '&#10003; Adjustable lumbar';
        if (hasTag(tags, ['lumbar support', 'lumbar']) || inStr(title, ['lumbar'])) return '&#10003; Lumbar support';
        if (hasTag(tags, ['posture']) || inStr(title, ['posture'])) return '&#10003; Posture support';
        return NA;

      case 'chair_height':
        /* Almost all office chairs have gas height adjustment — only confirm if chair */
        if (inStr(title, CHAIR_TITLE) || inStr(ptype, CHAIR_TYPES)) return '&#10003; Gas height adjustment';
        return NA;

      /* ── Storage-specific fields ── */
      case 'storage_type':
        if (inStr(title, ['pedestal'])) return 'Pedestal';
        if (inStr(title, ['filing cabinet', 'filing'])) return 'Filing cabinet';
        if (inStr(title, ['tambour'])) return 'Tambour unit';
        if (inStr(title, ['cupboard'])) return 'Cupboard';
        if (inStr(title, ['locker'])) return 'Locker';
        if (inStr(title, ['bookcase'])) return 'Bookcase';
        if (inStr(title, ['cabinet'])) return 'Cabinet';
        if (inStr(title, ['drawer'])) return 'Drawer unit';
        if (inStr(ptype, ['pedestal'])) return 'Pedestal';
        if (inStr(ptype, ['filing'])) return 'Filing cabinet';
        if (inStr(ptype, ['cupboard'])) return 'Cupboard';
        return NA;

      case 'storage_colour':
        if (inStr(title, ['white'])) return 'White';
        if (inStr(title, ['grey', 'gray'])) return 'Grey';
        if (inStr(title, ['black'])) return 'Black';
        if (inStr(title, ['beech'])) return 'Beech';
        if (inStr(title, ['oak'])) return 'Oak';
        if (inStr(title, ['walnut'])) return 'Walnut';
        if (inStr(title, ['silver'])) return 'Silver';
        if (inStr(title, ['maple'])) return 'Maple';
        return NA;

      case 'storage_material':
        if (inStr(title, ['steel', 'metal'])) return 'Steel';
        if (inStr(title, ['wood', 'wooden', 'mfc', 'melamine'])) return 'Wood / MFC';
        if (inStr(ptype, ['steel', 'metal'])) return 'Steel';
        if (inStr(ptype, ['wood', 'mfc'])) return 'Wood / MFC';
        return NA;

      case 'storage_drawers':
        var drawerMatch = title.match(/(\d+)\s*drawer/);
        if (drawerMatch) return drawerMatch[1] + ' drawers';
        var drawerTag = (tags || []).find(function (t) { return /\d+\s*drawer/i.test(t); });
        if (drawerTag) { var dm = drawerTag.match(/(\d+)/); return dm ? dm[1] + ' drawers' : NA; }
        return NA;

      case 'storage_lock':
        if (inStr(title, ['lock', 'lockable']) || hasTag(tags, ['lock', 'lockable'])) return '&#10003; Lockable';
        return NA;

      case 'storage_shelves':
        var shelfMatch = title.match(/(\d+)\s*shelf|shelv/);
        if (shelfMatch) return shelfMatch[1] + ' shelves';
        if (inStr(title, ['shelf', 'shelves', 'shelving']) || hasTag(tags, ['shelf', 'shelves'])) return '&#10003; Yes';
        return NA;

      /* ── Desk-specific fields ── */
      case 'desk_type':
        if (inStr(title, ['sit-stand', 'sit stand', 'height adjustable', 'standing'])) return 'Height-adjustable / sit-stand';
        if (inStr(title, ['corner'])) return 'Corner desk';
        if (inStr(title, ['bench'])) return 'Bench desk';
        if (inStr(title, ['straight', 'rectangular'])) return 'Straight desk';
        if (inStr(ptype, ['corner'])) return 'Corner desk';
        if (inStr(ptype, ['bench'])) return 'Bench desk';
        return NA;

      case 'desk_finish':
        if (inStr(title, ['white'])) return 'White';
        if (inStr(title, ['grey', 'gray'])) return 'Grey';
        if (inStr(title, ['black'])) return 'Black';
        if (inStr(title, ['beech'])) return 'Beech';
        if (inStr(title, ['oak'])) return 'Oak';
        if (inStr(title, ['walnut'])) return 'Walnut';
        if (inStr(title, ['maple'])) return 'Maple';
        return NA;

      case 'desk_frame':
        if (inStr(title, ['silver frame', 'silver leg'])) return 'Silver frame';
        if (inStr(title, ['black frame', 'black leg'])) return 'Black frame';
        if (inStr(title, ['white frame', 'white leg'])) return 'White frame';
        if (inStr(title, ['wooden leg', 'oak leg'])) return 'Wooden leg';
        return NA;

      case 'desk_heightadj':
        if (inStr(title, ['electric', 'motorised', 'motorized'])) return '&#10003; Electric';
        if (inStr(title, ['manual', 'crank'])) return '&#10003; Manual';
        if (inStr(title, ['sit-stand', 'sit stand', 'height adjustable', 'standing'])) return '&#10003; Yes';
        return 'No';

      case 'desk_cable':
        if (inStr(title, ['cable']) || hasTag(tags, ['cable management'])) return '&#10003; Yes';
        return NA;

      /* ── Table-specific fields ── */
      case 'table_type':
        if (inStr(title, ['boardroom'])) return 'Boardroom table';
        if (inStr(title, ['meeting'])) return 'Meeting table';
        if (inStr(title, ['training'])) return 'Training table';
        if (inStr(title, ['folding'])) return 'Folding table';
        if (inStr(title, ['canteen'])) return 'Canteen table';
        if (inStr(title, ['poseur'])) return 'Poseur / tall table';
        return NA;

      case 'table_fold':
        if (inStr(title, ['folding', 'foldable'])) return '&#10003; Yes';
        return 'No';

      /* ── Generic / mixed ── */
      case 'generic_finish':
        var finishes = ['white','grey','gray','black','beech','oak','walnut','maple','silver','mesh','fabric','leather'];
        for (var fi = 0; fi < finishes.length; fi++) {
          if (inStr(title, [finishes[fi]])) return finishes[fi].charAt(0).toUpperCase() + finishes[fi].slice(1);
        }
        return NA;

      case 'generic_material':
        if (inStr(title, ['steel', 'metal'])) return 'Steel';
        if (inStr(title, ['wood', 'mfc', 'melamine'])) return 'Wood / MFC';
        if (inStr(title, ['mesh'])) return 'Mesh';
        if (inStr(title, ['fabric'])) return 'Fabric';
        if (inStr(title, ['leather'])) return 'Leather';
        return NA;

      default:
        return NA;
    }
  }

  /* ─────────────────────────────────────────────────────
     BUILD COMPARISON TABLE
  ───────────────────────────────────────────────────── */
  function buildTable() {
    var body = document.getElementById('oft-cmp-modal-body');
    if (!body) return;

    var cat    = dominantCategory(items);
    var fields = FIELDS[cat] || FIELDS.other;

    /* Category label for modal title */
    var catLabels = { chair: 'Chairs', desk: 'Desks', storage: 'Storage', table: 'Tables', mixed: 'Products', other: 'Products' };
    var modalTitle = document.querySelector('#oft-cmp-modal-bg h2');
    if (modalTitle) modalTitle.textContent = 'Compare ' + (catLabels[cat] || 'Products');

    /* Header row */
    var thead = '<tr><th class="lbl"></th>';
    items.forEach(function (item) {
      thead += '<th>' +
        (item.image ? '<img src="' + esc(item.image) + '" style="width:80px;height:80px;object-fit:contain;border-radius:8px;background:#f5f5f5;display:block;margin-bottom:8px;padding:4px" alt="" onerror="this.style.display=\'none\'">' : '') +
        '<div style="font-size:13px;font-weight:700;color:#121212;margin-bottom:4px;line-height:1.3">' + esc(item.title) + '</div>' +
        '<div style="font-size:16px;font-weight:700;color:#df6060;margin-bottom:6px">' + money(item.price) + '</div>' +
        (isRefurb(item) ? '<span class="oft-badge-refurb">Refurbished</span>' : '<span class="oft-badge-new">New</span>') +
        '</th>';
    });
    thead += '</tr>';

    /* Data rows — skip rows where ALL values are NA */
    var tbody = '';
    fields.forEach(function (f) {
      var vals = items.map(function (item) { return derive(item, f.key); });
      /* Skip row if every value is NA and it’s not a core field */
      var coreKeys = ['price', 'brand', 'condition', 'delivery', 'warranty'];
      var allNA = vals.every(function (v) { return v === NA; });
      if (allNA && coreKeys.indexOf(f.key) === -1) return;

      tbody += '<tr><td class="lbl">' + esc(f.label) + '</td>';
      vals.forEach(function (v, i) {
        var cls = '';
        if (f.key === 'price') {
          var nums = vals.map(function (x) { return parseFloat(x.replace(/[^0-9.]/g, '')) || 0; });
          var min = Math.min.apply(null, nums);
          var thisNum = parseFloat(vals[i].replace(/[^0-9.]/g, '')) || 0;
          if (nums.some(function (n) { return n !== min; }) && thisNum === min) cls = ' class="best"';
        }
        tbody += '<td' + cls + '>' + (v === NA ? '<span style="color:#bbb">' + NA + '</span>' : v) + '</td>';
      });
      tbody += '</tr>';
    });

    /* CTA row */
    tbody += '<tr><td class="lbl"></td>';
    items.forEach(function (item) {
      tbody += '<td><a href="' + esc(item.url) + '" style="display:inline-block;background:#df6060;color:#fff;border-radius:7px;padding:8px 16px;font-size:12.5px;font-weight:700;text-decoration:none">View Product</a></td>';
    });
    tbody += '</tr>';

    body.innerHTML = '<table class="oft-cmp-tbl"><thead>' + thead + '</thead><tbody>' + tbody + '</tbody></table>';
  }

  /* ─────────────────────────────────────────────────────
     PUBLIC API
  ───────────────────────────────────────────────────── */
  window.oftCmpAdd = function (id, title, price, image, url, condition, vendor, tags, ptype) {
    id = String(id);
    if (byId(id)) { window.oftCmpRemove(id); return; }
    if (items.length >= MAX) { showMaxMsg(); return; }
    items.push({
      id:        id,
      title:     String(title || ''),
      price:     String(price || '0'),
      image:     String(image || ''),
      url:       String(url || ''),
      condition: String(condition || 'New'),
      vendor:    String(vendor || ''),
      tags:      Array.isArray(tags) ? tags : String(tags || '').split('|').filter(Boolean),
      ptype:     String(ptype || '')
    });
    save(); renderAll();
  };

  window.oftCmpRemove = function (id) {
    items = items.filter(function (x) { return x.id !== String(id); });
    save(); renderAll();
  };

  window.oftCmpClear = function () {
    items = []; save(); renderAll(); closeModal();
  };

  window.oftCmpRenderBar = function () { renderAll(); };

  window.oftCmpOpenModal = function () {
    if (items.length < 2) return;
    buildTable();
    var bg = document.getElementById('oft-cmp-modal-bg');
    if (bg) { bg.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
  };

  window.oftCmpCloseModal = function () {
    var bg = document.getElementById('oft-cmp-modal-bg');
    if (bg) { bg.style.display = 'none'; document.body.style.overflow = ''; }
  };

  function closeModal() { window.oftCmpCloseModal(); }

  function showMaxMsg() {
    var msg = document.getElementById('oft-cmp-max-msg');
    if (!msg) return;
    msg.style.display = 'inline-block';
    clearTimeout(msg._t);
    msg._t = setTimeout(function () { msg.style.display = 'none'; }, 3000);
  }

  /* ─────────────────────────────────────────────────────
     RENDER BAR
  ───────────────────────────────────────────────────── */
  function renderAll() { renderBar(); updateButtons(); }

  function renderBar() {
    var bar     = document.getElementById('oft-cmp-bar');
    var slotsEl = document.getElementById('oft-cmp-slots');
    var openBtn = document.getElementById('oft-cmp-open-btn');
    if (!bar || !slotsEl) return;

    var html = '';
    for (var i = 0; i < MAX; i++) {
      var item = items[i];
      if (item) {
        var refurb = isRefurb(item);
        var badge  = refurb
          ? '<span style="display:inline-block;background:#e8f0fe;color:#1a55af;font-size:9px;font-weight:700;padding:1px 5px;border-radius:10px;line-height:1.6">Refurbished</span>'
          : '<span style="display:inline-block;background:#eafaf1;color:#1a7a3c;font-size:9px;font-weight:700;padding:1px 5px;border-radius:10px;line-height:1.6">New</span>';
        var shortT = item.title.length > 32 ? item.title.slice(0, 31) + '\u2026' : item.title;
        html += '<div class="oft-slot filled">' +
          (item.image ? '<img class="oft-slot-img" src="' + esc(item.image) + '" alt="" onerror="this.style.display=\'none\'" loading="lazy">' : '<div class="oft-slot-img"></div>') +
          '<div class="oft-slot-info">' +
            '<span class="oft-slot-title">' + esc(shortT) + '</span>' +
            '<span class="oft-slot-price">' + money(item.price) + '</span>' +
            badge +
          '</div>' +
          '<button class="oft-slot-remove" data-remove="' + esc(item.id) + '" type="button" aria-label="Remove">&#215;</button>' +
          '</div>';
      } else {
        html += '<div class="oft-slot">+ Add a product</div>';
      }
    }
    slotsEl.innerHTML = html;

    slotsEl.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        window.oftCmpRemove(btn.dataset.remove);
      });
    });

    if (openBtn) openBtn.disabled = items.length < 2;

    if (items.length > 0) {
      bar.style.transform = 'translateY(0)';
      setTimeout(function () {
        var main = document.getElementById('MainContent');
        if (main) main.style.paddingBottom = (bar.offsetHeight + 20) + 'px';
      }, 50);
    } else {
      bar.style.transform = 'translateY(110%)';
      var main = document.getElementById('MainContent');
      if (main) main.style.paddingBottom = '';
    }
  }

  function updateButtons() {
    var atMax = items.length >= MAX;
    document.querySelectorAll('.oft-compare-trigger[data-pid]').forEach(function (btn) {
      var pid   = String(btn.dataset.pid);
      var inCmp = !!byId(pid);
      btn.classList.toggle('oft-in-cmp',  inCmp);
      btn.classList.toggle('oft-cmp-max', atMax && !inCmp);
      var lbl = btn.querySelector('.oft-cmp-btn-lbl');
      if (lbl) lbl.textContent = inCmp ? 'Added \u2713' : 'Compare';
    });
  }

  /* ─────────────────────────────────────────────────────
     EVENT DELEGATION — reads data-ptype from button
  ───────────────────────────────────────────────────── */
  function bindButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.oft-compare-trigger[data-pid]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      window.oftCmpAdd(
        btn.dataset.pid,
        btn.dataset.title     || '',
        btn.dataset.price     || '0',
        btn.dataset.image     || '',
        btn.dataset.url       || window.location.pathname,
        btn.dataset.condition || 'New',
        btn.dataset.vendor    || '',
        (btn.dataset.tags     || '').split('|').filter(Boolean),
        btn.dataset.ptype     || ''
      );
    });
  }

  /* ─────────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────────── */
  function init() {
    /* Clear old localStorage keys from previous versions */
    ['oft_cmp_v3','oft_cmp_v4','oft_cmp_v5'].forEach(function (k) {
      try { localStorage.removeItem(k); } catch (e) { }
    });

    load();

    var bar = document.getElementById('oft-cmp-bar');
    if (bar) {
      bar.style.transition = 'transform 0.3s ease';
      bar.style.transform  = 'translateY(110%)';
      bar.style.visibility = 'visible';
    }

    bindButtons();
    renderAll();

    var modalBg = document.getElementById('oft-cmp-modal-bg');
    if (modalBg) {
      modalBg.addEventListener('click', function (e) {
        if (e.target === modalBg) closeModal();
      });
    }

    window.addEventListener('resize', function () {
      if (items.length > 0) {
        var b = document.getElementById('oft-cmp-bar');
        var m = document.getElementById('MainContent');
        if (b && m) m.style.paddingBottom = (b.offsetHeight + 20) + 'px';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
